import Modal from '../common/modal';
interface Props {
  visible?: boolean | undefined;
  handlePrompt: () => void;
  closeModal: () => void;
  handleContinueSave?: () => void;
  titleText: string;
  contentText: string;
  cancelButtonText: string;
  confirmButtonText: string;
  confirmSaveButtonText?: string;
}
const AlertBox = ({
  visible,
  titleText,
  contentText,
  cancelButtonText,
  confirmButtonText,
  confirmSaveButtonText,
  handlePrompt,
  closeModal,
  handleContinueSave,
}: Props) => {
  return (
    <Modal
      isModel={visible}
      InnerComponent={
        <div
          className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:align-middle"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                  {titleText}
                </h3>
                <div className="mt-2 flex">
                  <p className="flex items-center text-sm text-gray-500">{contentText}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            {confirmSaveButtonText && (
              <button
                type="button"
                onClick={handleContinueSave}
                className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
              >
                {confirmSaveButtonText}
              </button>
            )}
            <button
              type="button"
              onClick={handlePrompt}
              className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
            >
              {confirmButtonText}
            </button>
            <button
              type="button"
              className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:ml-3 sm:mt-0 sm:w-auto sm:text-sm"
              onClick={closeModal}
            >
              {cancelButtonText}
            </button>
          </div>
        </div>
      }
    ></Modal>
  );
};
export default AlertBox;
